import { genericFetchingActionCreator, genericPostingActionCreator, getCookieValue } from 'app/actions/genericActionCreator'
import { catchCommonErrors } from 'app/actions/commonActionUtils'

export const fetchRecords = () => {
  return (dispatch) => {
    dispatch(genericFetchingActionCreator('NADLRecords', 'fetching'))
    fetch('/lgyhub/api/nadl', {
      method: 'GET',
      credentials: 'include'
    }).then((response) => {
      return catchCommonErrors(dispatch, response, 'NADL Records')
    }).then((response) => {
      dispatch(genericFetchingActionCreator('NADLRecords', 'fetched', { nadlRecords: (response || []) }))
    }).catch((error) => {
      console.error('There has been a problem getting NADL Records:', error)
    })
  }
}

export const addRecord = (record) => {
  return (dispatch) => {
    dispatch(genericPostingActionCreator('NADLRecords', 'posting'))
    return fetch('/lgyhub/api/nadl', {
      method: 'POST',
      credentials: 'include',
      body: JSON.stringify(record),
      headers: new Headers({
        'Content-Type': 'application/json',
        'X-XSRF-TOKEN': getCookieValue('XSRF-TOKEN')
      })
    }).then((response) => {
      return catchCommonErrors(dispatch, response, 'adding this record')
    }).then(() => {
      dispatch(genericPostingActionCreator('NADLRecords', 'posted'))
      dispatch(fetchRecords())
    }).catch((error) => {
      console.error('There has been a problem adding the record:', error)
    })
  }
}

export const updateRecord = (id, record) => {
  return (dispatch) => {
    dispatch(genericPostingActionCreator('NADLRecords', 'posting'))
    return fetch('/lgyhub/api/nadl/update/' + id, {
      method: 'POST',
      credentials: 'include',
      body: JSON.stringify(record),
      headers: new Headers({
        'Content-Type': 'application/json',
        'X-XSRF-TOKEN': getCookieValue('XSRF-TOKEN')
      })
    }).then((response) => {
      return catchCommonErrors(dispatch, response, 'updating this record')
    }).then(() => {
      dispatch(genericPostingActionCreator('NADLRecords', 'posted'))
      dispatch(fetchRecords())
    }).catch((error) => {
      console.error('There has been a problem adding the record:', error)
    })
  }
}

export const fetchDateRangeReport = (fromDate, toDate) => {
  return (dispatch) => {
    dispatch(genericFetchingActionCreator('NADLRecords', 'fetching'))
    fetch('/lgyhub/api/nadl/dateRangeReport', {
      method: 'POST',
      credentials: 'include',
      body: JSON.stringify({ fromDate, toDate }),
      headers: new Headers({
        'Content-Type': 'application/json',
        'X-XSRF-TOKEN': getCookieValue('XSRF-TOKEN')
      })
    }).then((response) => {
      return catchCommonErrors(dispatch, response, 'NADL Records')
    }).then((response) => {
      dispatch(genericFetchingActionCreator('NADLRecords', 'fetched', { nadlRecords: (response || []) }))
    }).catch((error) => {
      console.error('There has been a problem getting NADL Records:', error)
    })
  }
}